<form [formGroup]="form" autocomplete="off" class="form-horizontal">

  <div class="form-row">
    <label class="col-sm-8 col-form-label"
           for="hoeheDerBeteiligungNominell{{index}}">{{ 'COMMON_UI.FRAGEBOGEN.ANTEILSEIGNER.HOEHE_DER_BETEILIGUNG_NOMINELL' | translate }}</label>
    <div class="col-sm-4">
      <input (change)="onNominellChanged($event.target['value'])" class="form-control text-right pr-3x" datevMessagePath="hoeheDerBeteiligungNominell{{objectId}}"
             formControlName="hoeheDerBeteiligungNominell{{index}}"
             id="hoeheDerBeteiligungNominell{{index}}" placeholder="Euro, Cent" type="text" numeric transformNumber
             utilsCheckValidity
             utilsControlState utilsMarkRequired
             utilsValidationMessage/>
      <em class="icon icon-euro"></em>
    </div>
  </div>

  <div class="form-row">
    <label class="col-sm-8 col-form-label"
           for="hoeheDerBeteiligungProzent{{index}}">{{ 'COMMON_UI.FRAGEBOGEN.ANTEILSEIGNER.HOEHE_DER_BETEILIGUNG_PROZENT' | translate }}</label>
    <div class="col-sm-4">
      <input type="text" numeric decimal transformNumber digitsInfo=".2-4"
             (change)="onProzentChanged($event.target['value'])" class="form-control text-right pr-3x" datevMessagePath="hoeheDerBeteiligungProzent{{objectId}}"
             formControlName="hoeheDerBeteiligungProzent{{index}}"
             id="hoeheDerBeteiligungProzent{{index}}" placeholder="0,00"
             utilsCheckValidity utilsControlState utilsMarkRequired utilsValidationMessage/>
      <em class="icon icon-prozent"></em>
    </div>
  </div>

</form>
